import axios from 'axios';
import { buildRequests } from '../util/buildRequest';
import { DOMAIN } from '../util/constants';
import { SetAuthHeader } from '../util/SetAuthHeader';
import { SetLanguageHeader } from '../util/SetLanguageHeader';
import { SetResponseInterceptor } from '../util/SetResponseInterceptor';

const API = `${DOMAIN}/api/v1/iam`;
const instance = axios.create({
  baseURL: API,
});

instance.interceptors.request.use(SetAuthHeader);
instance.interceptors.request.use(SetLanguageHeader);
SetResponseInterceptor(instance);

const requests = buildRequests(instance);

const publicIamInstance = axios.create({
  baseURL: API,
});

publicIamInstance.interceptors.request.use(SetLanguageHeader);

const publicIamRequests = buildRequests(publicIamInstance);

export { API as IAM_API, requests as iam_api_requests, publicIamRequests as public_iam_api_requests };
